/* src/app/layout/card-view-layout/list-view-simple-card/list-view-simple-card.component.css */
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 10px;
  width: 100%;
  height: 50px;
  margin: 5px;
  display: inline-block;
  cursor: pointer;
}
@media screen and (max-width: 1450px) {
  .card {
    width: 90%;
  }
}
@media screen and (max-device-width: 500px) {
  .card {
    width: 100%;
  }
  h4 {
    font-size: 0.5pt;
  }
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.container {
  padding: 2px 16px;
}
.content {
  display: block;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 3.6em;
  height: 3.6em;
  line-height: 1.8em;
}
.actions {
  display: absolute;
  align-content: right;
  margin: 5px;
  background: purple;
}
.action {
  display: block;
  float: right;
  margin-left: 10px;
  opacity: 0.4;
  transition: 0.3s;
}
.red {
  color: black;
  transition: 0.3s;
}
.red:hover {
  opacity: 1 !important;
  color: red;
}
.action:hover {
  opacity: 1;
}
.add-icon {
  text-align: center;
  font-size: 55pt;
}
.add-card {
  opacity: 0.4;
  transition: 0.3s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.add-card:hover {
  opacity: 1;
}
.clear {
  display: absolute;
  float: right;
  margin-left: 10px;
  opacity: 0.4;
  transition: 0.3s;
}
.clear:hover {
  opacity: 1;
}
/*# sourceMappingURL=list-view-simple-card.component.css.map */
